import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { ProductBlockAction } from "./product-block.action";
import { ProductBlockState } from "./product-block.model";

const INITIAL_STATE: ProductBlockState = {
	products: [],
};

export const productBlockReducer = createReducer(
	INITIAL_STATE,
	on(ProductBlockAction.getSuccess, ProductBlockAction.updateSuccess, (state, { products }) =>
		updateState(state, { products })
	),
	on(ProductBlockAction.clear, () => INITIAL_STATE)
);
